export default __webpack_public_path__ + "static/media/air-handling-unit.1850fe6c.png";